module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mensagemPropria",
    class: {
      'm-b': _vm.mensagem.showAvatar
    }
  }, [_c('p', {
    staticClass: "msg",
    class: {
      startMessage: _vm.mensagem.startMessage,
      break: _vm.mensagem.showAvatar && !_vm.mensagem.startMessage,
      continue: !_vm.mensagem.showAvatar
    }
  }, [_vm._v("\n    " + _vm._s(_vm.mensagem.mensagem) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c7d718b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatConversaMensagemPropria.vue
// module id = 1796
// module chunks = 18